import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { MODAL_HIDE, SNACKBAR_HIDE, MODAL_SHOW, MODAL_USER_SET_ETH_ADDRESS } from '../../../constants/action-types';

class WorkInProgress extends Component {
    constructor(props) {
        super(props);
        this.state = ({closed : false})
    }

    hideSnackbar(ev) {

        ev.preventDefault()
        //this.props.closeSnackbar()
        this.setState({closed : true});

    }
 

    render() {
        return (
            <div id='yellowsnackbar' className={this.state.closed ? 'hide' : ''}>
                <span className='icon icon-x' onClick={this.hideSnackbar.bind(this)}></span>
                <small>THIS PLATFORM IS STILL BEING DEVELOPED, PLEASE EMPTY CACHE INTERMITTENTLY FOR LATEST VERSION</small>
            </div>);
    }
}

const mapStateToProps = (state) => state

const mapDispatchToProps = (dispatch) => ({ 
    closeSnackbar: (email) => dispatch({ type: SNACKBAR_HIDE })
});

export default WorkInProgress


// WEBPACK FOOTER //
// ./src/components/templates/snackbars/work-in-progress.js